// extracted by mini-css-extract-plugin
module.exports = {"new-indicator":"service-insight-heading_new-indicator__juZMJ","hide-view-all-desktop":"service-insight-heading_hide-view-all-desktop__tkoDb"};